
import React, { useState, createContext, useContext} from "react";
import useToken from "shared/hook/useToken";
const { openMenu } = useToken();
const SidebarContext = createContext();
export function userSidebarContext(){
  return useContext(SidebarContext);
}

const SidebarContextProvider = (props) => {
  const { children } = props;
  const [first, setFirst] = useState(true);
  const [openSidebar, setOpenSidebar] = useState(first ? openMenu : false);
  return (
  <SidebarContext.Provider 
    value={{
      openSidebar,
      onSetOpenSidebar: (bool) => {
        setOpenSidebar(bool);
        if(first){
          setFirst(false)
        }
      } ,
    }}
  >
    {children}
  </SidebarContext.Provider>
)};

export default SidebarContextProvider;